/** Meta Pixel (Facebook) — ID: 1525239232974950 */
export const META_PIXEL_ID = '1525239232974950'

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue: unknown[]
  push: Fbq
  loaded: boolean
  version: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

/** Betölti a Meta Pixelt és elküldi a PageView eseményt (pontosan a hivatalos snippet logikája szerint). */
export function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  const n = function (...args: unknown[]) {
    if (n.callMethod) n.callMethod(...args)
    else n.queue.push(args)
  } as Fbq
  window.fbq = n
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = document.getElementsByTagName('script')[0]
  if (s?.parentNode) s.parentNode.insertBefore(t, s)
  else document.head.appendChild(t)

  window.fbq('init', META_PIXEL_ID)
  window.fbq('track', 'PageView')
}
